(() => {
  if (window.RokidHalloweenSwiss) { window.RokidHalloweenSwiss.mount(document); return; }
  const instances = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(pointer: fine)');
  const hoverCapable = matchMedia('(hover: hover)');
  const wide = matchMedia('(min-width: 900px)');
  function init(root) {
    if (instances.has(root)) return;
    const abort = new AbortController();
    const popup = root.querySelector('[data-rh-swiss-popup]');
    const popupImage = popup.querySelector('img');
    const bay = root.querySelector('[data-rh-swiss-bay]');
    const metrics = [...root.querySelectorAll('[data-rh-swiss-metric]')];
    let frame = 0;
    let previous = 0;
    let active = null;
    let showing = false;
    let keyboard = false;
    let introObserver = null;
    let targetX = 0;
    let targetY = 0;
    const values = {x:0,y:0,reveal:0};
    const velocities = {x:0,y:0,reveal:0};
    const listen = (target,type,callback) => target.addEventListener(type,callback,{signal:abort.signal});
    const movingAllowed = () => !root.hasAttribute('data-rh-swiss-inline') && !reduced.matches && fine.matches && hoverCapable.matches && wide.matches && !keyboard && !document.hidden && !window.Shopify?.designMode;
    const paint = () => {
      popup.style.setProperty('--rh-swiss-x', values.x + 'px');
      popup.style.setProperty('--rh-swiss-y', values.y + 'px');
      popup.style.setProperty('--rh-swiss-scale', .6 + .4 * values.reveal);
      popup.style.setProperty('--rh-swiss-opacity', Math.max(0,Math.min(1,values.reveal)));
    };
    const stop = () => {
      cancelAnimationFrame(frame);
      frame = previous = 0;
      popup.removeAttribute('data-rh-swiss-moving');
    };
    const clearMetric = () => {
      active?.removeAttribute('data-rh-swiss-active');
      active = null;
    };
    const reset = () => {
      stop(); clearMetric(); showing = false; popup.hidden = true;
      Object.assign(values,{x:0,y:0,reveal:0});
      Object.assign(velocities,{x:0,y:0,reveal:0});
      targetX = targetY = 0;
      paint();
    };
    const updateMode = () => {
      reset();
      root.dataset.rhSwissMotion = String(movingAllowed());
      if (reduced.matches) {root.dataset.rhSwissEnter = 'shown';introObserver?.disconnect();}
    };
    const tick = time => {
      frame = 0;
      if (!movingAllowed() || !root.isConnected) { reset(); return; }
      const elapsed = Math.min(.032,Math.max(.001,(time - (previous || time - 16.667))/1000));
      previous = time;
      const steps = Math.ceil(elapsed / (1/120));
      const dt = elapsed / steps;
      const targets = {x:targetX,y:targetY,reveal:showing ? 1 : 0};
      for (let step = 0; step < steps; step++) for (const key of Object.keys(values)) {
        const stiffness = key === 'reveal' ? 400 : 300;
        const damping = key === 'reveal' ? 25 : 30;
        velocities[key] += (stiffness * (targets[key] - values[key]) - damping * velocities[key]) * dt;
        values[key] += velocities[key] * dt;
      }
      const settled = Object.keys(values).every(key => Math.abs(targets[key]-values[key]) < (key === 'reveal' ? .001 : .02) && Math.abs(velocities[key]) < (key === 'reveal' ? .01 : .1));
      if (settled) {
        Object.assign(values,targets); Object.assign(velocities,{x:0,y:0,reveal:0});
        paint(); stop(); if (!showing) popup.hidden = true;
      } else { paint(); frame = requestAnimationFrame(tick); }
    };
    const animate = () => {
      if (!movingAllowed()) { reset(); return; }
      popup.dataset.rhSwissMoving = 'true';
      if (!frame) frame = requestAnimationFrame(tick);
    };
    const setPosition = (metric,event) => {
      const slot = bay.getBoundingClientRect();
      const row = metric.getBoundingClientRect();
      const width = Math.min(280,window.innerWidth - 32);
      const minX = Math.max(16,slot.left);
      const maxX = Math.min(window.innerWidth - width - 16,slot.right - width);
      const minY = Math.max(16,slot.top);
      const maxY = Math.min(window.innerHeight - 216,slot.bottom - 200);
      if (maxX < minX || maxY < minY) return false;
      const ratio = Math.max(0,Math.min(1,(event.clientX - row.left) / Math.max(1,row.width)));
      targetX = minX + (maxX-minX) * ratio;
      targetY = Math.max(minY,Math.min(maxY,event.clientY - 100));
      if (popup.hidden) { values.x = targetX; values.y = targetY; }
      return true;
    };
    const leave = () => { clearMetric(); showing = false; if (!popup.hidden) animate(); };
    for (const metric of metrics) {
      const image = metric.querySelector('img');
      const fallback = metric.querySelector('[data-rh-swiss-image-error]');
      if (image) {
        const fail = () => { image.hidden = true; fallback.hidden = false; if (active === metric) reset(); };
        listen(image,'error',fail);
        if (image.complete && !image.naturalWidth) fail();
      }
      const enter = event => {
        if (event.pointerType !== 'mouse') return;
        if (keyboard) { keyboard = false; updateMode(); }
        if (!movingAllowed() || !image || image.hidden || !setPosition(metric,event)) return;
        clearMetric(); active = metric; metric.dataset.rhSwissActive = 'true';
        popupImage.src = image.currentSrc || image.src;
        popup.hidden = false; showing = true; animate();
      };
      listen(metric,'pointerenter',enter);
      listen(metric,'pointermove',event => {
        if (event.pointerType !== 'mouse') return;
        if (keyboard) { enter(event); return; }
        if (active !== metric || !movingAllowed()) return;
        if (!setPosition(metric,event)) { reset(); return; }
        animate();
      });
      listen(metric,'pointerleave',leave);
      listen(metric,'blur',reset);
    }
    listen(popupImage,'error',reset);
    listen(root,'pointerleave',leave);
    listen(window,'blur',reset);
    listen(window,'pointercancel',reset);
    listen(window,'pointerdown',event => { if (event.pointerType !== 'mouse') reset(); });
    listen(window,'resize',updateMode);
    listen(window,'scroll',reset);
    listen(document,'visibilitychange',updateMode);
    listen(document,'keydown',event => {
      if (event.key === 'Escape') reset();
      if (event.key === 'Tab') { keyboard = true; updateMode(); }
    });
    for (const query of [reduced,fine,hoverCapable,wide]) listen(query,'change',updateMode);
    updateMode();
    if (typeof IntersectionObserver !== 'undefined' && !reduced.matches) {
      root.dataset.rhSwissEnter = 'pending';
      introObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {root.dataset.rhSwissEnter = 'shown';introObserver.disconnect();}
      },{threshold:.1});
      introObserver.observe(root);
    }
    instances.set(root,{dispose:() => {reset();abort.abort();introObserver?.disconnect();root.removeAttribute('data-rh-swiss-motion');root.removeAttribute('data-rh-swiss-enter');},get active(){return frame !== 0;}});
  }
  function mount(scope) {
    if (scope.matches?.('[data-rh-swiss-section]')) init(scope);
    scope.querySelectorAll('[data-rh-swiss-section]').forEach(init);
  }
  function unmount(scope) {
    for (const [root,instance] of instances) if (root === scope || scope.contains(root)) {instance.dispose();instances.delete(root);}
  }
  window.RokidHalloweenSwiss = {mount,unmount,get instanceCount(){return instances.size;},get activeFrameCount(){return [...instances.values()].filter(item => item.active).length;}};
  document.addEventListener('shopify:section:load',event => mount(event.target));
  document.addEventListener('shopify:section:unload',event => unmount(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => mount(document),{once:true});
  else mount(document);
})();
